/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SeminarRegistrationSource {
    WIDGET = 'widget',
    PUBLIC_PAGE = 'public_page',
    THERAPIST = 'therapist',
    CLIENT_PORTAL = 'client_portal',
}
